import BoutonPrincipal from './BoutonPrincipal';

function NotreJunior() {
  return (
    <div className="px-4 py-10">
      <div className="bg-sky-100 dark:bg-bleu-gris flex flex-col lg:flex-row items-center gap-10 max-w-7xl mx-auto p-6 rounded-lg">
        <div className="w-full lg:w-1/2">
          <img src="./images/equipe_2026.avif" alt="L'équipe i2c" className="rounded-lg shadow-md w-full object-cover"/>
        </div>
        
        <div className="text-gray-700 w-full lg:w-1/2 flex flex-col items-center text-justify gap-4">
          <h1 className="text-2xl text-bleu-footer dark:text-bleu-sombre font-semibold">Notre Junior-Entreprise</h1>
          <p className="dark:text-fond-sombre text-base md:text-lg font-normal leading-relaxed md:mr-2 lg:mr-3">
            La Junior-Entreprise de l’ENSC, i2c, met son expertise en cognitique et sciences de
            l’ingénieur au service de vos projets. Depuis sa création, i2c se distingue par son
            approche unique qui conjugue expertise humaine et innovation technologique. Nous
            intervenons dans divers domaines :
          </p>
          <ul className="dark:text-fond-sombre list-disc list-inside text-base md:text-lg font-normal leading-relaxed md:mr-2 lg:mr-3 space-y-2">
            <li>Ingénierie (création de sites web, d'applications, de bases de données)</li>
            <li>Conseil (audits ergonomiques, analyses statistiques)</li>
            <li>Cognitique (conception centrée utilisateur, UI/UX, gestion des connaissances)</li>
          </ul>
          
          <div className="mt-4">
            <BoutonPrincipal titre={'En savoir plus'} lien="mandat" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotreJunior;